import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { Route, Router } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService,private toastr: ToastrService,private route: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const currentUrl = window.location.href;
            // ✅ Skip handling if URL includes /pdf/order
            if (!currentUrl.includes('/pdf/order')) {
                    if (err.status === 401) {
                        this.toastr.error('Session expired. Please login again.', 'Error',)
                        sessionStorage.clear();
                        localStorage.clear();
                        this.route.navigate(['/account/login']);
                        // this.authenticationService.logout();
                        // location.reload();
                    }

            }

            const error = err.error.message || err.statusText;
            return throwError(error);
        }));
    }
}
